import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Email = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M2 7.5A2.5 2.5 0 0 1 4.5 5h15A2.5 2.5 0 0 1 22 7.5v10a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 17.5v-10Zm1.88 0v.86l6.73 5.53c.8.67 1.97.67 2.78 0l6.73-5.53v-.9c0-.3-.28-.62-.62-.62h-15a.65.65 0 0 0-.63.62v.04Zm0 3.29v6.71c0 .34.27.63.62.63h15c.34 0 .63-.29.63-.63v-6.71l-5.55 4.55a4.11 4.11 0 0 1-5.2 0l-5.5-4.55Z"
    />
  </svg>
));
